import React from "react";
import "./messages.css";

const Modal = ({
  isOpen,
  onClose,
  onSubmit,
  newMessage,
  setNewMessage,
  editMessageId,
}) => {
  if (!isOpen) return null;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (newMessage.trim() !== "") {
      onSubmit();
      onClose();
    } else {
      alert("Bericht mag niet leeg zijn!");
    }
  };

  return (
    <div className="modal-overlay styled-modal">
      <div className="modal-box">
        <h2 className="modal-title">
          {editMessageId ? "Bewerk bericht" : "Nieuw bericht"}
        </h2>
        <form onSubmit={handleSubmit}>
          <textarea
            className="modal-textarea"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            rows={8}
            placeholder="Typ hier je bericht..."
          />
          <div className="modal-button-row">
            <button type="submit" className="newmsgbutton">
              {editMessageId ? "Opslaan" : "Toevoegen"}
            </button>
            <button type="button" className="delete-button" onClick={onClose}>
              Annuleren
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Modal;
